import React from "react"

function Arrow(props) {
    return (
        <svg
        className="w-7  h-auto group-hover:translate-x-24 transition-transform duration-500"
        viewBox="0 0 39 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2 11.5h34m0 0L27.5 3m8.5 8.5L27.5 20"
          stroke="#0C1414"
          strokeWidth={3}
          strokeLinecap="square"
        />
      </svg>
    )
  }

export default Arrow